export default {"src":"https://static.influitive.com/_next/static/media/file.ac500c18.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};